import React from "react";
import Terms from "./Terms";
import TwoFactorMFA from "./TwoFactorMFA/TwoFactorMFA";
import NotificationPreference from "./NotificationPreference/NotificationPreference";
import PersonalInformationForm from "./PersonalInformation/PersonalInformationForm";
import AddressInformation from "./PersonalInformation/AddressInformation";
import {
    STEP_PERSONAL_INFORMATION_USER_INFORMATION,
    STEP_PERSONAL_INFORMATION_ADDRESS_INFORMATION,
    STEP_TERMS_OF_USE,
    STEP_TWO_FACTOR_AUTHENTICATION,
    STEP_NOTIFICATION_PREFERENCE,
} from "./ReCompleteRegistrationUtil";

const RegistrationComponents = (props: any) => {
    const getTimelineClass = (step: number) => {
        return props.reCompleteRegistrationState.step > step ? "timeline-past" : props.reCompleteRegistrationState.step === step ? "timeline-current" : "";
    };

    return (
        <>
            {
                <div>
                    <div className=" row">
                        <div className="col-xs-12">
                            <div className="timeline-container">
                                <ol className="timeline steps-4">
                                    <li
                                        data-label="1"
                                        className={
                                            props.reCompleteRegistrationState.step === STEP_PERSONAL_INFORMATION_USER_INFORMATION ||
                                            props.reCompleteRegistrationState.step === STEP_PERSONAL_INFORMATION_ADDRESS_INFORMATION
                                                ? "timeline-current"
                                                : "timeline-past"
                                        }
                                    >
                                        <span className="sr-only">Current Step: </span>
                                        <span>Personal Information</span>
                                    </li>
                                    <li data-label="2" className={getTimelineClass(STEP_TERMS_OF_USE)}>
                                        <span>Terms</span>
                                    </li>
                                    <li data-label="3" className={getTimelineClass(STEP_TWO_FACTOR_AUTHENTICATION)}>
                                        <span>Authentication</span>
                                    </li>
                                    <li data-label="4" className={getTimelineClass(STEP_NOTIFICATION_PREFERENCE)}>
                                        <span>Notification Preferences</span>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>

                    {props.reCompleteRegistrationState.step === STEP_PERSONAL_INFORMATION_USER_INFORMATION && (
                        <PersonalInformationForm
                            registrationLookup={props.reCompleteRegistrationState}
                            setReCompleteRegistrationState={props.setReCompleteRegistrationState}
                        />
                    )}
                    {props.reCompleteRegistrationState.step === STEP_PERSONAL_INFORMATION_ADDRESS_INFORMATION && (
                        <AddressInformation
                            registrationLookup={props.reCompleteRegistrationState}
                            setReCompleteRegistrationState={props.setReCompleteRegistrationState}
                        />
                    )}
                    {props.reCompleteRegistrationState.step === STEP_TWO_FACTOR_AUTHENTICATION && (
                        <TwoFactorMFA
                            reCompleteRegistrationState={props.reCompleteRegistrationState}
                            setReCompleteRegistrationState={props.setReCompleteRegistrationState}
                        />
                    )}
                    {props.reCompleteRegistrationState.step === STEP_TERMS_OF_USE && (
                        <Terms
                            reCompleteRegistrationState={props.reCompleteRegistrationState}
                            setReCompleteRegistrationState={props.setReCompleteRegistrationState}
                        />
                    )}
                    {props.reCompleteRegistrationState.step === STEP_NOTIFICATION_PREFERENCE && (
                        <NotificationPreference
                            reCompleteRegistrationState={props.reCompleteRegistrationState}
                            setReCompleteRegistrationState={props.setReCompleteRegistrationState}
                        />
                    )}
                </div>
            }
        </>
    );
};

export default RegistrationComponents;
